var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavClientJobMappings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 48,
    viewBox: "0 0 70 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2415 17.7915H0V32.102H21.2415V17.7915Z",
    fill: "#35A4E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1688 33.5029H23.9272V47.8135H45.1688V33.5029Z",
    fill: "#35A4E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4857 1.875H47.2441V16.1855H68.4857V1.875Z",
    fill: "#35A4E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8094 30.9096H1.42529V16.4287H22.8094V30.9096ZM1.56785 30.7392H22.6668V16.5991H1.56785V30.7392Z",
    fill: "#35A4E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4476 30.9096H25.0635V16.4287H46.4476V30.9096ZM25.206 30.7392H46.305V16.5991H25.206V30.7392Z",
    fill: "#585860"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8001 14.9809H48.416V0.5H69.8001V14.9809ZM48.5586 14.8105H69.6575V0.670363H48.5586V14.8105Z",
    fill: "#35A4E8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8802 14.9809H1.49609V0.5H22.8802V14.9809ZM1.63865 14.8105H22.7376V0.670363H1.63865V14.8105Z",
    fill: "#585860"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4476 14.9809H25.0635V0.5H46.4476V14.9809ZM25.206 14.8105H46.305V0.670363H25.206V14.8105Z",
    fill: "#585860"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7293 46.8183H48.3452V32.3374H69.7293V46.8183ZM48.4878 46.6479H69.5867V32.5078H48.4878V46.6479Z",
    fill: "#585860"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8094 46.8183H1.42529V32.3374H22.8094V46.8183ZM1.56785 46.6479H22.6668V32.5078H1.56785V46.6479Z",
    fill: "#585860"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3768 46.8183H24.9927V32.3374H46.3768V46.8183ZM25.1352 46.6479H46.2342V32.5078H25.1352V46.6479Z",
    fill: "#35A4E8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8001 30.9096H48.416V16.4287H69.8001V30.9096ZM48.5586 30.7392H69.6575V16.5991H48.5586V30.7392Z",
    fill: "#585860"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavClientJobMappings);
export default __webpack_public_path__ + "static/media/nav-client-job-mappings.d85df4b89a8098bb54b7057dbac47fe6.svg";
export { ForwardRef as ReactComponent };